import React, { useContext, useState } from 'react'
import { login, request_new_password } from '../server/server'
import { logLoginTime } from '../utils/usersData'
const AuthContext = React.createContext()

const AuthProvider = (props) => {
    const [user, setUser] = useState()
    const data = { user: user, setUser: setUser }

    const loginUser = async ({ email, password }) => {
        const startTime = Date.now()
        try {
            const response = await login({ email, password })
            const endTime = Date.now()

            const logLoginTimeData = {
                start_time: startTime,
                end_time: endTime,
                device: 'desktop',
                success: response.status === 200,
                user_id: response?.data?.id,
                email: email,
                serverError: 500 <= response?.status && response?.status < 599,
            }
            logLoginTime(logLoginTimeData)
            if (response.status === 200) {
                const data = response.data
                if (data.role > 0) {
                    const token = data['token']
                    window.open(`https://web.alkalmaup.com?token=${token}`, '_self')
                    return { data: "You will be redirected to teachers's page...", success: false }
                }
                localStorage.setItem('userToken', data['token'])
                localStorage.setItem('loginDate', Date.now())
                localStorage.setItem('user', JSON.stringify(data))
                return { data: data, success: true }
            } else {
                return { data: response.data, success: false }
            }
        } catch (e) {
            const endTime = Date.now()

            const logLoginTimeData = {
                start_time: startTime,
                end_time: endTime,
                device: 'desktop',
                success: false,
                email: email,
                serverError: true,
                message: e,
            }
            logLoginTime(logLoginTimeData)
            return { data: e, success: false }
        }
    }

    const logoutUser = () => {
        localStorage.removeItem('userToken')
        localStorage.removeItem('user')
        localStorage.removeItem('temporaryAccess')
        document.title = `AlkalmaUp`
        setUser(null)
    }

    return <AuthContext.Provider value={{ data, loginUser, logoutUser }} {...props} />
}

function useAuth() {
    const context = useContext(AuthContext)

    if (context === undefined) {
        throw new Error(`useAuth must be used within a AuthProvider`)
    }
    return context
}

export { AuthProvider, useAuth }
